"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var translate_exports = {};
__export(translate_exports, {
  Translate: () => Translate
});
module.exports = __toCommonJS(translate_exports);
var Translate;
((Translate2) => {
  let Missing;
  ((Missing2) => {
    Missing2.path = "translate/missing";
  })(Missing = Translate2.Missing || (Translate2.Missing = {}));
})(Translate || (Translate = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Translate
});
